export default "__VITE_ASSET__BMj$4__V__"